import useMediaQuery from '@mui/material/useMediaQuery';

export const XS = 'xs';
export const SM = 'sm';
export const MD = 'md';
export const LG = 'lg';
export const XL = 'xl';
export const SIZE = { XS, SM, MD, LG, XL };

export default function ScreenSize() {
  let size;
  const xs = useMediaQuery('(min-width: 0px)');
  const sm = useMediaQuery('(min-width: 600px)');
  const md = useMediaQuery('(min-width: 960px)');
  const lg = useMediaQuery('(min-width: 1280px)');
  const xl = useMediaQuery('(min-width: 1920px)');
  if (xs) {
    size = XS;
  }
  if (sm) {
    size = SM;
  }
  if (md) {
    size = MD;
  }
  if (lg) {
    size = LG;
  }
  if (xl) {
    size = XL;
  }

  return size;
}
